import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 5CB87909-09B4-47FD-B4BF-EB4A949F3CA2
 * name glass-cocktail-off
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/glass-cocktail-off.svg
 * tags
 * - Food / Drink 
 */
export const GlassCocktailOffIcon = createSvgIcon(<><path d="M13.33 12.67L7.66 7L6.13 5.47L2.39 1.73L1.11 3L3 4.89V5L11 13V19H6V21H18V19.89L20.84 22.73L22.11 21.46L13.33 12.67M13 19V14.89L17.11 19H13M8.2 5L6.2 3H21V5L14.6 11.4L10.2 7H16.5L18.5 5H8.2Z" /></>, 'GlassCocktailOffIcon');
export default GlassCocktailOffIcon